import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';
import {RouteAssignment, RouteAssignmentQueue, VehicleRouteAssignmentStatus} from '../../shared/models/route-assignment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteAssignmentService {

  constructor(private http: HttpClient) { }

  getRouteAssignments(
      timeFrom: Date,
      vehicleId: number,
      shiftId: number,
      routeConfigId: number,
      routeIds: number[],
      includeCompleted: boolean = true,
      includeDeleted: boolean = false,
      includeDeclined: boolean = false,
  ) {
    let params: HttpParams = new HttpParams()
        .set('includeCompleted', includeCompleted)
        .set('includeDeleted', includeDeleted)
        .set('includeDeclined', includeDeclined);
    if (!!timeFrom) {
      params = params.set('timeFrom', timeFrom.toISOString());
    }
    if (!!vehicleId) {
      params = params.set('vehicleId', vehicleId);
    }
    if (!!shiftId) {
      params = params.set('shiftId', shiftId);
    }
    if (!!routeConfigId) {
      params = params.set('routeConfigId', routeConfigId);
    }
    if (!!routeIds && routeIds.length > 0) {
      params = params.set('routeIds', routeIds.join(':::'));
    }
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<RouteAssignment[]>>(
            `${environment.services.service}v1/route-assignment/list`, {params}
        )
        .pipe(
            catchError(HttpErrorHandler.handleError)
        )
    );
  }

  createRouteAssignment(assignments: RouteAssignment[], queueOrder: RouteAssignmentQueue) {
    return firstValueFrom(
      this.http
        .post<JsonApiResponse<RouteAssignment[]>>(
          `${environment.services.service}v1/route-assignment/create/${queueOrder}`,
          assignments
        )
        .pipe(
            catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  deleteRouteAssignment(assignment: RouteAssignment) {
    return firstValueFrom(
      this.http
        .post(
          `${environment.services.service}v1/route-assignment/delete`,
          assignment,
        )
        .pipe(
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  getVehicleStatus() {
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<VehicleRouteAssignmentStatus[]>>(
          `${environment.services.service}v1/route-assignment/vehicle-status`, {}
        )
        .pipe(
            catchError(HttpErrorHandler.handleError)
        )
    );
  }

  reOrderRouteAssignments(vehicleId: number, shiftId: number, routeAssignmentIds: number[]) {
    let params: HttpParams = new HttpParams();
    if (shiftId) {
      params = params.set('shiftId', shiftId);
    }
    return firstValueFrom(
      this.http
        .post<JsonApiResponse<RouteAssignment[]>>(
          `${environment.services.service}v1/route-assignment/vehicle/${vehicleId}/reOrder`,
          routeAssignmentIds,
          {
            params
          },
        )
        .pipe(
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }
}
